import { useApi } from "../auth";
import { useEffect, useState } from "react";
import Loading from "./Loading";
import { backend_url, non_organs } from "../constants";
import Stack from "react-bootstrap/Stack";
import BMDPlot from "./BMDPlot";
import BMDBoxes from "./BMDBoxes";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { observer } from "mobx-react-lite";
import ExecutingProgress from "./ExecutingProgress";
import SimulatedStudyPlot from "./SimulatedStudyPlot";

function PODs({ store, isPrinting }) {
  const [bmdsShown, setBmdsShown] = useState(18);
  const [hideNonOrgans, setHideNonOrgans] = useState(false);
  let [shownStudyPlot, setShownStudyPlot] = useState(null);
  let runObject = store.runObject;
  let object = store.bmdObject;
  let endpointObject = store.endpointObject;
  if (store.loading) return <Loading />;
  if (!object) return <div>Not found</div>;
  if (!object.has_executed) {
    return <ExecutingProgress now={object.execution_progress} />
  }
  let sortedBMDs = object.bmd_jsons
    .filter((x) => x.no_trend_count / x.iterations < 0.5)
    .sort((o1, o2) => o1.bmd - o2.bmd);
  let getPlotting = (endpoint, organ)=>{
    let ejson = object.bmd_jsons.filter((x)=>x.endpoint==endpoint.endpoint && x.organ==endpoint.organ)
    console.log(ejson);
    if(ejson.length ==0){
      return undefined
    }
    ejson = ejson[0]
    return {
      "mid": ejson.plotting,
      "lower": ejson.plotting_lower,
      "upper": ejson.plotting_upper,
    }
  }
  if (hideNonOrgans) {
    sortedBMDs = sortedBMDs.filter((x) => !non_organs.includes(x.organ));
  }
  let bmdsToPlot = sortedBMDs.slice(0, 15);
  let bmdsToBox;
  if (isPrinting) {
    bmdsToBox = sortedBMDs;
  } else {
    bmdsToBox = sortedBMDs.slice(0, bmdsShown);
  }
  let experimentObject = store.experimentObject;
  if(!experimentObject){
    return <Loading />;
  }
  let trial = experimentObject.initial ? experimentObject : experimentObject.preferred_trial;
  return (
    <Stack className="BMD-container" gap={3}>
      <div className="BMD-plot">
        <h4>Benchmark Dose (BMD) Estimation</h4>
        <p>Estimated BMD values with 95% Confidence Intervals.</p>

        <BMDPlot bmdObjects={bmdsToPlot} doseUnit={runObject.dose_unit} />
        {isPrinting ? null : (
          <Form>
            <Form.Check
              type="switch"
              id="custom-switch"
              label="Hide Non-Organ Level Endpoints"
              onChange={(e) => setHideNonOrgans(e.target.checked)}
              checked={hideNonOrgans}
            />
          </Form>
        )}
      </div>
      <div className="BMD-boxes">
        <BMDBoxes bmdObjects={bmdsToBox} doseUnit={runObject.dose_unit} setShownStudyPlot={setShownStudyPlot} />
        {shownStudyPlot != null ? (
          <div className="PODStudyPlotHolder">
            <div className="studyPlotHolderHeader">
              <h3>
                {shownStudyPlot}
              </h3>
              <div>
                <span
                  style={{
                    cursor: "pointer",
                    fontVariationSettings:
                      "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 36",
                  }}
                  className="material-symbols-rounded"
                  onClick={() => setShownStudyPlot(null)}
                >
                  close
                </span>
              </div>
            </div>
            {endpointObject.endpoint_ranks.map((endpoint) => (
              <SimulatedStudyPlot
                percentiles={endpoint.data_percentiles}
                doses={trial.doses}
                show={`${endpoint.organ}_${endpoint.endpoint}` == shownStudyPlot}
                doseUnit={runObject.dose_unit}
                endpoint={`${endpoint.organ}_${endpoint.endpoint}`}
                plotting={getPlotting(endpoint)}
              />
            ))}
          </div>
        ) : null}
        {bmdsShown < sortedBMDs.length && !isPrinting ? (
          <Button
            onClick={(e) => {
              e.preventDefault();
              setBmdsShown(bmdsShown + 9);
            }}
            className="dt-button"
            variant="primary"
            type="submit"
            style={{ width: "10rem", marginLeft: "44%" }}
          >
            Show More BMDs
          </Button>
        ) : null}
      </div>
    </Stack>
  );
}

export default observer(PODs);
